// extracted by mini-css-extract-plugin
export default {"ResultBlock":"Result_ResultBlock__RfoMm","title":"Result_title__eXBVK","value":"Result_value__P4Mso"};